import { render, staticRenderFns } from "./LinkdialogOpener.vue?vue&type=template&id=5ad79705&"
import script from "./LinkdialogOpener.vue?vue&type=script&lang=js&"
export * from "./LinkdialogOpener.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports